import { CheckCircle2, XCircle, TrendingUp, TrendingDown } from 'lucide-react';

export default function ForecastCard({ sym, issueRef, projected, actual, direction, error, attribution }) {
  const isHit = direction === 'hit' || direction === 'beat';
  return (
    <div className="fc-card">
      <div className="fc-head">
        <span>{issueRef} · Today's Final · {sym}</span>
        <span className={`badge ${isHit ? 'b-hit' : 'b-miss'}`}>
          {isHit ? <CheckCircle2 size={9} /> : <XCircle size={9} />}
          {isHit ? 'Hit' : 'Miss'}
        </span>
      </div>
      <div className="fc-body">
        <div className="fc-items">
          <div className="fc-item">
            <div className="fc-lbl">Projected</div>
            <div className="fc-val">{projected}</div>
          </div>
          <div className="fc-arrow">→</div>
          <div className="fc-item">
            <div className="fc-lbl">Actual close</div>
            <div className={`fc-val${isHit ? ' g' : ''}`}>{actual}</div>
          </div>
          <div className="fc-item">
            <div className="fc-lbl">Direction</div>
            <div className={`fc-val${isHit ? ' g' : ''}`}>
              {isHit ? 'Correct ✓' : 'Incorrect ✗'}
            </div>
          </div>
          <div className="fc-item">
            <div className="fc-lbl">Error</div>
            <div className="fc-val">{error}</div>
          </div>
        </div>
        {attribution && (
          <div className="fc-note">
            <strong>Attribution:</strong> {attribution}
          </div>
        )}
      </div>
    </div>
  );
}
